// extracted by mini-css-extract-plugin
module.exports =  {"note":"_93444fe79c--note--nEmFA","danger":"_93444fe79c--danger--NmWYA","icon":"_93444fe79c--icon--OGqPJ","cont":"_93444fe79c--cont--mpDSg"};